export default __webpack_public_path__ + "static/media/globeTechMobile.959ed4da.png";